import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Header = ({ className = "" }) => {
	const [isNavbarActive, setIsNavbarActive] = useState(false);
	const location = useLocation();
	const navigate = useNavigate();

	// Handle navbar toggle
	const toggleNavbar = () => {
		setIsNavbarActive(!isNavbarActive);
	};

	// Close navbar when clicking on links
	const closeNavbar = () => {
		setIsNavbarActive(false);
	};

	// Handle navigation to sections
	const handleSectionNavigation = (sectionId) => {
		closeNavbar();

		if (sectionId === "home") {
			// Always navigate to home page and scroll to top
			if (location.pathname !== "/") {
				navigate("/", { state: { scrollTo: "home" } });
			} else {
				window.scrollTo({ top: 0, behavior: "smooth" });
			}
		} else if (sectionId === "contact") {
			// For contact, scroll to contact section on current page
			const contactElement = document.querySelector(
				'[data-section="contact"]'
			);
			if (contactElement) {
				contactElement.scrollIntoView({ behavior: "smooth" });
			} else {
				// If no contact section found, navigate to home page contact
				if (location.pathname !== "/") {
					navigate("/", { state: { scrollTo: "contact" } });
				} else {
					const element = document.getElementById("contact");
					if (element) {
						element.scrollIntoView({ behavior: "smooth" });
					}
				}
			}
		} else {
			// For other sections, navigate to home page first
			if (location.pathname !== "/") {
				navigate("/", { state: { scrollTo: sectionId } });
			} else {
				const element = document.getElementById(sectionId);
				if (element) {
					element.scrollIntoView({ behavior: "smooth" });
				}
			}
		}
	};

	return (
		<header className="relative z-20 w-full">
			<div className="container">
				<div
					className={`flex items-center justify-between py-4 px-6 bg-black/20 backdrop-blur-sm rounded-full mx-4 ${className}`}
				>
					{/* Logo */}
					<Link to="/" className="flex items-center space-x-3">
						<img
							src="/assets/images/Swift-logo.jpg"
							alt="Swift Haven Logo"
							className="w-10 h-10 rounded-lg object-cover"
						/>
						<span className="text-white font-light text-xl font-generalSans">
							Swift Haven
						</span>
					</Link>

					{/* Desktop Navigation */}
					<nav className="hidden lg:flex items-center space-x-8 text-white">
						<button
							onClick={() => handleSectionNavigation("home")}
							className="font-light text-l hover:text-swift-pink transition-colors duration-300 font-generalSans"
						>
							Home
						</button>
						<Link
							to="/about"
							className="font-light text-l hover:text-swift-pink transition-colors duration-300 font-generalSans"
							onClick={closeNavbar}
						>
							About Us
						</Link>
						<Link
							to="/team"
							className="font-light text-l hover:text-swift-pink transition-colors duration-300 font-generalSans"
							onClick={closeNavbar}
						>
							The Team
						</Link>
						<button
							onClick={() => handleSectionNavigation("contact")}
							className="bg-swift-pink hover:bg-swift-pink/80 text-white px-4 py-2 rounded-full transition-colors duration-300 font-light text-l font-generalSans"
						>
							Contact Us
						</button>
					</nav>

					{/* Mobile Menu Button */}
					<button
						className="lg:hidden p-2 text-white hover:text-swift-pink transition-colors duration-300"
						onClick={toggleNavbar}
						aria-label="Toggle navigation menu"
					>
						<svg
							className="w-6 h-6"
							fill="none"
							stroke="currentColor"
							viewBox="0 0 24 24"
						>
							{isNavbarActive ? (
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M6 18L18 6M6 6l12 12"
								/>
							) : (
								<path
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth={2}
									d="M4 6h16M4 12h16M4 18h16"
								/>
							)}
						</svg>
					</button>
				</div>

				{/* Mobile Navigation */}
				<div
					className={`mx-4 lg:hidden absolute top-full left-0 right-0 bg-black/50 backdrop-blur-sm rounded-lg mt-2 transition-all duration-300 ${
						isNavbarActive
							? "opacity-100 pointer-events-auto"
							: "opacity-0 pointer-events-none"
					}`}
				>
					<div className="p-6">
						<nav className="space-y-4">
							<button
								onClick={() => handleSectionNavigation("home")}
								className="block w-full text-left text-white font-light text-l hover:text-swift-pink transition-colors duration-300 font-generalSans"
							>
								Home
							</button>
							<Link
								to="/about"
								className="block text-white font-light text-l hover:text-swift-pink transition-colors duration-300 font-generalSans"
								onClick={closeNavbar}
							>
								About Us
							</Link>
							<Link
								to="/team"
								className="block text-white font-light text-l hover:text-swift-pink transition-colors duration-300 font-generalSans"
								onClick={closeNavbar}
							>
								The Team
							</Link>
							<button
								onClick={() =>
									handleSectionNavigation("contact")
								}
								className="block w-full bg-swift-pink hover:bg-swift-pink/80 text-white px-4 py-2 rounded-lg transition-colors duration-300 font-light text-l font-generalSans"
							>
								Contact Us
							</button>
						</nav>
					</div>
				</div>
			</div>
		</header>
	);
};

export default Header;
